/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const mobileNavStyle = {
  mobileNav: (theme: Theme) => ({
    position: "absolute",
    top: "calc(100%)",
    left: 0,
    right: 0,
    height: "calc(100dvh - 4rem)", // 4rem = header height on sm
    backgroundColor: theme.palette.background.default,
    transform: "translateY(-100%)",
    transition: "all 200ms ease-in-out",
    zIndex: -1,
    padding: "1.5rem 1rem 2rem 1rem",
    justifyContent: "space-between",
    gap: "2rem",
    color: theme.palette.text.primary,
    [theme.breakpoints.up("md")]: {
      height: "calc(100dvh - 5rem)", // 5rem = header height on md
    },
  }),
  withNavComp: {
    padding: 0,
  },
  active: {
    transform: "translateY(1px)",
    overflow: "hidden",
  },
};
